import { render, staticRenderFns } from "./improve-personnel.vue?vue&type=template&id=3255ac18&scoped=true&"
import script from "./improve-personnel.vue?vue&type=script&lang=js&"
export * from "./improve-personnel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3255ac18",
  null
  
)

export default component.exports